import { deleteRequest, getRequest, hasAuthToken, patchRequest, postRequest } from 'features/common'
import { Group, GroupUpdatePayload, GroupMember } from '../types'
import settings from 'settings'

const BASE_URL = `${settings.accountsApiUrl}/accounts/groups`

export const getGroups = async (): Promise<Group[] | undefined> => {
  if (!(await hasAuthToken())) {
    return undefined
  }

  const params = new URLSearchParams({
    isPaginated: 'false'
  })

  return getRequest(`${BASE_URL}?${params.toString()}`) as Promise<Group[]>
}

export const updateGroup = (groupId: unknown, payload: GroupUpdatePayload['payload']): Promise<Group> => {
  return patchRequest(`${BASE_URL}/${groupId}`, payload)
}

export const deleteGroup = (groupId: string): Promise<Group> => {
  return deleteRequest(`${BASE_URL}/${groupId}`)
}

export const createGroup = (data: Partial<Group>): Promise<Group> => postRequest(BASE_URL, data)

export const getGroupMembers = async (groupId: string): Promise<GroupMember[] | undefined> => {
  if (!(await hasAuthToken())) {
    return undefined
  }
  return getRequest(`${BASE_URL}/${groupId}/users`)
}
